module.exports = __webpack_public_path__ + "images/e7ddcc40d58c1c6239df3973695882e3-app_store.png";